
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";

// Get Table Data
export const BeneficiaryDetailsTableDataAPI = createAsyncThunk("BeneficiaryDetailsTableData", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        M_StateNameID,
        M_RegionalOfficeID,
        M_DistrictNameID,
        SurveyorName,
        FromTop,
        ToTop,
        M_TableUserMasterID,
        BeneficiaryName,
        M_TalukaNameID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
   
    return fetch(`${BaseUrl}/Transaction/Get_Web_M_BeneficiaryDetails_Select?M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_StateNameID=${M_StateNameID}&M_RegionalOfficeID=${M_RegionalOfficeID}&M_DistrictNameID=${M_DistrictNameID}&M_TalukaNameID=${M_TalukaNameID}&SurveyorName=${SurveyorName}&BeneficiaryName=${BeneficiaryName}&M_TableUserMasterID=${M_TableUserMasterID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    return result.data
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const BeneficiaryDetailsTableDataSlice = createSlice({
    name: "BeneficiaryDetailsTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BeneficiaryDetailsTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(BeneficiaryDetailsTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(BeneficiaryDetailsTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const BeneficiaryDetailsTableDataReducer = BeneficiaryDetailsTableDataSlice.reducer


// Get Table Data
export const BeneficiaryDetailsPopUpTableDataAPI = createAsyncThunk("BeneficiaryDetailsPopUpTableData", async ({ data }) => {
    const {
        M_BeneficiaryDetailsID,
        Flag,
        M_TableUserMasterID,
        token,
        setBeneficiaryDetails,
        setBeneficiaryPackaging,
        setCreditLinkage,

    } = data

    // console.log(Flag)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Transaction/Get_APK_M_BeneficiaryDetails_Select?M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag} `, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {


                if (Flag == "BeneficiaryDetails") {
                    setBeneficiaryDetails(result.data.table)
                } if (Flag == "BeneficiaryPackaging") {
                    // console.log("data",result.data)
                    setBeneficiaryPackaging(result.data.table)
                } if (Flag == 'BeneficiaryCreditLinkage') {
                    // console.log("result",result.data.table)
                    setCreditLinkage(result.data.table)
                }
                return result.data.table

            } else {
                // toastError(result.message)
                return result
            }
        })
})

const BeneficiaryDetailsPopUpTableDataSlice = createSlice({
    name: "BeneficiaryDetailsPopUpTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BeneficiaryDetailsPopUpTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(BeneficiaryDetailsPopUpTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(BeneficiaryDetailsPopUpTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const BeneficiaryDetailsPopUpTableDataReducer = BeneficiaryDetailsPopUpTableDataSlice.reducer

// Planting Material Packaging Post API

export const PlantingMaterialPackagingPostAPI = createAsyncThunk("PlantingMaterialPackagingPost", async ({ data }) => {
    const {
        M_BeneficiaryDetailsID,
        RawData,
        M_TableUserMasterID,
        token,
        handleDataIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("RawData", RawData);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_M_BeneficiaryDetails_PlanMaterial_Packaging_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleDataIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const PlantingMaterialPackagingPostSlice = createSlice({
    name: "PlantingMaterialPackagingPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantingMaterialPackagingPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(PlantingMaterialPackagingPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(PlantingMaterialPackagingPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const PlantingMaterialPackagingPostReducer = PlantingMaterialPackagingPostSlice.reducer

// Credit Linkage Post API

export const CreditLinkagePostAPI = createAsyncThunk("CreditLinkagePost", async ({ data }) => {
    const {
        M_BeneficiaryDetailsID,
        CreditLinkage,
        M_TableUserMasterID,
        token,
        handleIsCreditLinkageData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("CreditLinkage", CreditLinkage);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_M_BeneficiaryDetails_CreditLinkage_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsCreditLinkageData()

                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const CreditLinkagePostSlice = createSlice({
    name: "CreditLinkagePost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(CreditLinkagePostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(CreditLinkagePostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(CreditLinkagePostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const CreditLinkagePostReducer = CreditLinkagePostSlice.reducer

export const BeneficiaryDetailsPostAPI = createAsyncThunk("BeneficiaryDetailsPost", async ({ data }) => {
    const {
       
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        SurveyDate,
        Age_M_IndicatorID,
        Gender_M_IndicatorID,
        Education_M_IndicatorID,
        MembersInHH_M_IndicatorID,
        LiveliHood_M_IndicatorID,
        MonthlyIncome,
        TotalLandArea,
        No_of_Plots,
        M_UnitID,
        TotalPlantation_M_IndicatorID,
        FurtherPlantation_M_IndicatorID,
        ReceivedFromID,
        DistanceFromNursery,
        NurseryName,
        PlantMaterialPayment_M_IndicatorID,
        CreditLinkage_M_IndicatorID,
        M_BeneficiaryPlotCode,
        Flag,
        M_TableUserMasterID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
   formdata.append("FinancialYearID", FinancialYearID);
formdata.append("MonthsID", MonthsID);
formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
formdata.append("SurveyDate", SurveyDate);
formdata.append("Age_M_IndicatorID", Age_M_IndicatorID);
formdata.append("Gender_M_IndicatorID", Gender_M_IndicatorID);
formdata.append("Education_M_IndicatorID", Education_M_IndicatorID);
formdata.append("MembersInHH_M_IndicatorID", MembersInHH_M_IndicatorID);
formdata.append("LiveliHood_M_IndicatorID",LiveliHood_M_IndicatorID);
formdata.append("MonthlyIncome", MonthlyIncome);
formdata.append("TotalLandArea", TotalLandArea);
formdata.append("No_of_Plots", No_of_Plots);
formdata.append("M_UnitID", M_UnitID);
formdata.append("TotalPlantation_M_IndicatorID", TotalPlantation_M_IndicatorID);
formdata.append("FurtherPlantation_M_IndicatorID", FurtherPlantation_M_IndicatorID);
formdata.append("ReceivedFromID", ReceivedFromID);
formdata.append("DistanceFromNursery", DistanceFromNursery);
formdata.append("NurseryName", NurseryName);
formdata.append("PlantMaterialPayment_M_IndicatorID", PlantMaterialPayment_M_IndicatorID);
formdata.append("CreditLinkage_M_IndicatorID", CreditLinkage_M_IndicatorID);
formdata.append("M_BeneficiaryPlotCode", M_BeneficiaryPlotCode);
formdata.append("Flag", Flag);
formdata.append("M_TableUserMasterID", M_TableUserMasterID);

const requestOptions = {
  method: "PATCH",
  body: formdata,
  redirect: "follow"
};

fetch(`${BaseUrl}/Transaction/APK_M_BeneficiaryDetails_Update`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const BeneficiaryDetailsPostSlice = createSlice({
    name: "BeneficiaryPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BeneficiaryDetailsPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(BeneficiaryDetailsPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(BeneficiaryDetailsPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const BeneficiaryDetailsPostReducer = BeneficiaryDetailsPostSlice.reducer

// ------------------------------ Planting Material Packaging Delete -----------------------------

export const PlantingMaterialPackagingDeleteAPI = createAsyncThunk("PlantingMaterialPackagingDelete", async ({ data }) => {
    const {
        M_BeneficiaryDetails_PlanMaterial_PackagingID,
        M_TableUserMasterID,
        token,
        handleDataIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_BeneficiaryDetails_PlanMaterial_PackagingID", M_BeneficiaryDetails_PlanMaterial_PackagingID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);
    
    const requestOptions = {
      method: "DELETE",
      body: formdata,
      redirect: "follow"
    };
    
    fetch(`${BaseUrl}/Transaction/APK_M_BeneficiaryDetails_PlanMaterial_Packaging_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleDataIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const PlantingMaterialPackagingDeleteSlice = createSlice({
    name: "PlantingMaterialPackagingDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantingMaterialPackagingDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(PlantingMaterialPackagingDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(PlantingMaterialPackagingDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const PlantingMaterialPackagingDeleteReducer = PlantingMaterialPackagingDeleteSlice.reducer

// ------------------------------ Credit Linkage Delete -----------------------------

export const CreditLinkageDeleteAPI = createAsyncThunk("CreditLinkageDelete", async ({ data }) => {
    const {
        M_BeneficiaryDetails_CreditLinkageID,
        M_TableUserMasterID,
        token,
        handleIsCreditLinkageData,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_BeneficiaryDetails_CreditLinkageID", M_BeneficiaryDetails_CreditLinkageID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);
    
    const requestOptions = {
      method: "DELETE",
      body: formdata,
      redirect: "follow"
    };
    
    fetch(`${BaseUrl}/Transaction/APK_M_BeneficiaryDetails_CreditLinkage_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsCreditLinkageData()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const CreditLinkageDeleteSlice = createSlice({
    name: "CreditLinkageDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(CreditLinkageDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(CreditLinkageDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(CreditLinkageDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const CreditLinkageDeleteReducer = CreditLinkageDeleteSlice.reducer

export const BeneficiaryDetailsDeleteAPI = createAsyncThunk("BeneficiaryDetailsDelete", async ({ data }) => {
    const {
        M_BeneficiaryDetailsID,
        M_TableUserMasterID,
        token,
        handleIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);
    
    const requestOptions = {
      method: "DELETE",
      body: formdata,
      redirect: "follow"
    };
    
    fetch(`${BaseUrl}/Transaction/APK_M_Beneficiary_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const BeneficiaryDetailsDeleteSlice = createSlice({
    name: "BeneficiaryDetailsDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BeneficiaryDetailsDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(BeneficiaryDetailsDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(BeneficiaryDetailsDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const BeneficiaryDetailsDeleteReducer = BeneficiaryDetailsDeleteSlice.reducer